import React, { useState } from "react";
import { inject, observer } from "mobx-react";
import Utility from "../../../../common/utility";
import CancelInvitation from "../CancelInvitation/CancelInvitation";

const MembersList = inject("sharedStore")(
  observer((store) => {
    const { sharedStore, visibleModal, closeModal, openModal, selectedUserId } = store;
    const userId = Utility.getData("userId");
    const userRole = sharedStore.userRole;
    const memberData = sharedStore.membersData
      ? sharedStore.membersData.slice()
      : [];
    memberData.forEach(function (item, i) {
      if (item.userId === userId) {
        memberData.splice(i, 1);
        memberData.unshift(item);
      }
    });
    return (
      memberData &&
      memberData.map((member, i) => {
        const setClassName =
          member.status === "default"
            ? "membersDelete"
            : member.status === "pending"
              ? "membersCancelInvite"
              : "membersDelete";
        return (
          <tr key={i}>
            <td className="label-td">
              {member.userId === userId ? member.name + ` (You)` : member.name}{" "}
              <span className="invite-status">
                {member.status === "pending" ? "Pending Invite" : null}
              </span>
            </td>
            <td>{member.email}</td>
            <td className="dropdown-td">{member.role}</td>

            <td>{Utility.getDate(member.created)}</td>
            {userRole !== 1 ? null : (
              <td className={setClassName}>
                {member.userId === userId ? null : member.status ===
                  "pending" ? (
                    <span
                      className="cursor-pointer"
                      onClick={() => openModal(member.userId)}
                    >
                      <i className="fa fa-close" aria-hidden="true" />
                  &nbsp; Cancel Invite
                    </span>
                  ) : (
                    <span
                      className="cursor-pointer"
                      onClick={() => openModal(member.userId)}
                    >
                      <i className="fa fa-trash" aria-hidden="true" />
                  &nbsp; Delete User
                    </span>
                  )}
                <CancelInvitation
                  modalVisibility={visibleModal}
                  userId={selectedUserId}
                  closeModalHandler={closeModal}
                  modalClass="iz-modal cancel-invite-modal"
                />
              </td>
            )}
          </tr>
        );
      })
    );
  }))

const Members = inject("sharedStore")(
  observer((store) => {
    const { sharedStore } = store;
    const [visibleModal, setModal] = useState(false)
    const [userId, setUserId] = useState("")


    const closeModal = () => {
      setModal(false)
    };
    const openModal = (userId) => {
      setModal(true)
      setUserId(userId)
    }
    return (
      <div className="table-responsive" id="teamsTable">
        <table className="striped-table w-100">
          <thead>
            <tr>
              <th>Member</th>
              <th>Email</th>
              <th>Role</th>
              <th>Created</th>
              {sharedStore.userRole === 1 ? <th>Options</th> : null}
            </tr>
          </thead>
          <tbody>{
            <MembersList
              visibleModal={visibleModal}
              selectedUserId={userId}
              closeModal={closeModal}
              openModal={openModal} />
          }</tbody>
        </table>
      </div>
    );
  }))


export default Members;



// WEBPACK FOOTER //
// ./src/components/Profile/MemberComponent/Members/Members.jsx